import { ROUTES_ACTIVATE_ACCOUNT } from '@/constants/routes';
import { post } from 'axios';

export default {
    name: ROUTES_ACTIVATE_ACCOUNT,
    path: '/activate-account/:code',
    async beforeEnter(to, from, next) {
        try {
            const {
                data: { data, status_code }
            } = await post(`${api}activate-account`, {
                grant_type: 'activation_code',
                activation_code: to.params.code,
                client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
                client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET
            });
            if (status_code === 400) {
                return next('/login');
            }
            if (data.accessToken) {
                localStorage.setItem('ludum_token', JSON.stringify(data.accessToken));
            }
            next('/home');
        } catch (error) {
            next('/login');
        }
    }
};
